'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

/**
 * Renders the initials SVG tag
 */
const AvatarInitialsSvg = ({ size, initials, foregroundColor, backgroundColor, }) => {
    return (React__default['default'].createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", role: "presentation" },
        React__default['default'].createElement("rect", { fill: backgroundColor, x: "0", y: "0", width: "24", height: "24" }),
        React__default['default'].createElement("text", { fill: foregroundColor, fontSize: "10px", fontWeight: 700, textAnchor: "middle", x: "12", y: "12", dominantBaseline: "central" }, initials)));
};

module.exports = AvatarInitialsSvg;
